export interface CountryOption {
  value: string
  label: string
  sublabel?: string
}

export const COUNTRY_OPTIONS: CountryOption[] = [
  // Top Featured / Arab & Muslim World
  { value: 'Palestine', label: '🇵🇸 Palestine', sublabel: 'فلسطين' },
  { value: 'Egypt', label: '🇪🇬 Egypt', sublabel: 'مصر' },
  {
    value: 'Saudi Arabia',
    label: '🇸🇦 Saudi Arabia',
    sublabel: 'المملكة العربية السعودية',
  },
  {
    value: 'United Arab Emirates',
    label: '🇦🇪 United Arab Emirates',
    sublabel: 'الإمارات العربية المتحدة',
  },
  { value: 'Kuwait', label: '🇰🇼 Kuwait', sublabel: 'الكويت' },
  { value: 'Qatar', label: '🇶🇦 Qatar', sublabel: 'قطر' },
  { value: 'Bahrain', label: '🇧🇭 Bahrain', sublabel: 'البحرين' },
  { value: 'Oman', label: '🇴🇲 Oman', sublabel: 'عمان' },
  { value: 'Jordan', label: '🇯🇴 Jordan', sublabel: 'الأردن' },
  { value: 'Lebanon', label: '🇱🇧 Lebanon', sublabel: 'لبنان' },
  { value: 'Syria', label: '🇸🇾 Syria', sublabel: 'سوريا' },
  { value: 'Iraq', label: '🇮🇶 Iraq', sublabel: 'العراق' },
  { value: 'Yemen', label: '🇾🇪 Yemen', sublabel: 'اليمن' },
  { value: 'Morocco', label: '🇲🇦 Morocco', sublabel: 'المغرب' },
  { value: 'Algeria', label: '🇩🇿 Algeria', sublabel: 'الجزائر' },
  { value: 'Tunisia', label: '🇹🇳 Tunisia', sublabel: 'تونس' },
  { value: 'Libya', label: '🇱🇾 Libya', sublabel: 'ليبيا' },
  { value: 'Sudan', label: '🇸🇩 Sudan', sublabel: 'السودان' },
  { value: 'Somalia', label: '🇸🇴 Somalia', sublabel: 'الصومال' },
  { value: 'Mauritania', label: '🇲🇷 Mauritania', sublabel: 'موريتانيا' },
  { value: 'Djibouti', label: '🇩🇯 Djibouti', sublabel: 'جيبوتي' },
  { value: 'Comoros', label: '🇰🇲 Comoros', sublabel: 'جزر القمر' },
  { value: 'Turkey', label: '🇹🇷 Turkey', sublabel: 'Türkiye' },
  { value: 'Pakistan', label: '🇵🇰 Pakistan', sublabel: 'پاکستان' },
  { value: 'Indonesia', label: '🇮🇩 Indonesia' },
  { value: 'Malaysia', label: '🇲🇾 Malaysia' },
  { value: 'Bangladesh', label: '🇧🇩 Bangladesh' },
  { value: 'Nigeria', label: '🇳🇬 Nigeria' },
  { value: 'United Kingdom', label: '🇬🇧 United Kingdom' },
  { value: 'United States', label: '🇺🇸 United States' },
  { value: 'Canada', label: '🇨🇦 Canada' },
  { value: 'Australia', label: '🇦🇺 Australia' },
  { value: 'Germany', label: '🇩🇪 Germany' },
  { value: 'France', label: '🇫🇷 France' },

  // All World Countries (Alphabetical - excluding Israel)
  { value: 'Afghanistan', label: '🇦🇫 Afghanistan' },
  { value: 'Albania', label: '🇦🇱 Albania' },
  { value: 'Andorra', label: '🇦🇩 Andorra' },
  { value: 'Angola', label: '🇦🇴 Angola' },
  { value: 'Antigua and Barbuda', label: '🇦🇬 Antigua and Barbuda' },
  { value: 'Argentina', label: '🇦🇷 Argentina' },
  { value: 'Armenia', label: '🇦🇲 Armenia' },
  { value: 'Austria', label: '🇦🇹 Austria' },
  { value: 'Azerbaijan', label: '🇦🇿 Azerbaijan' },
  { value: 'Bahamas', label: '🇧🇸 Bahamas' },
  { value: 'Barbados', label: '🇧🇧 Barbados' },
  { value: 'Belarus', label: '🇧🇾 Belarus' },
  { value: 'Belgium', label: '🇧🇪 Belgium' },
  { value: 'Belize', label: '🇧🇿 Belize' },
  { value: 'Benin', label: '🇧🇯 Benin' },
  { value: 'Bhutan', label: '🇧🇹 Bhutan' },
  { value: 'Bolivia', label: '🇧🇴 Bolivia' },
  { value: 'Bosnia and Herzegovina', label: '🇧🇦 Bosnia and Herzegovina' },
  { value: 'Botswana', label: '🇧🇼 Botswana' },
  { value: 'Brazil', label: '🇧🇷 Brazil' },
  { value: 'Brunei', label: '🇧🇳 Brunei' },
  { value: 'Bulgaria', label: '🇧🇬 Bulgaria' },
  { value: 'Burkina Faso', label: '🇧🇫 Burkina Faso' },
  { value: 'Burundi', label: '🇧🇮 Burundi' },
  { value: 'Cabo Verde', label: '🇨🇻 Cabo Verde' },
  { value: 'Cambodia', label: '🇰🇭 Cambodia' },
  { value: 'Cameroon', label: '🇨🇲 Cameroon' },
  { value: 'Central African Republic', label: '🇨🇫 Central African Republic' },
  { value: 'Chad', label: '🇹🇩 Chad' },
  { value: 'Chile', label: '🇨🇱 Chile' },
  { value: 'China', label: '🇨🇳 China' },
  { value: 'Colombia', label: '🇨🇴 Colombia' },
  { value: 'Congo (DRC)', label: '🇨🇩 Congo (DRC)' },
  { value: 'Congo (Republic)', label: '🇨🇬 Congo (Republic)' },
  { value: 'Costa Rica', label: '🇨🇷 Costa Rica' },
  { value: 'Croatia', label: '🇭🇷 Croatia' },
  { value: 'Cuba', label: '🇨🇺 Cuba' },
  { value: 'Cyprus', label: '🇨🇾 Cyprus' },
  { value: 'Czech Republic', label: '🇨🇿 Czech Republic' },
  { value: 'Denmark', label: '🇩🇰 Denmark' },
  { value: 'Dominica', label: '🇩🇲 Dominica' },
  { value: 'Dominican Republic', label: '🇩🇴 Dominican Republic' },
  { value: 'Ecuador', label: '🇪🇨 Ecuador' },
  { value: 'El Salvador', label: '🇸🇻 El Salvador' },
  { value: 'Equatorial Guinea', label: '🇬🇶 Equatorial Guinea' },
  { value: 'Eritrea', label: '🇪🇷 Eritrea' },
  { value: 'Estonia', label: '🇪🇪 Estonia' },
  { value: 'Eswatini', label: '🇸🇿 Eswatini' },
  { value: 'Ethiopia', label: '🇪🇹 Ethiopia' },
  { value: 'Fiji', label: '🇫🇯 Fiji' },
  { value: 'Finland', label: '🇫🇮 Finland' },
  { value: 'Gabon', label: '🇬🇦 Gabon' },
  { value: 'Gambia', label: '🇬🇲 Gambia' },
  { value: 'Georgia', label: '🇬🇪 Georgia' },
  { value: 'Ghana', label: '🇬🇭 Ghana' },
  { value: 'Greece', label: '🇬🇷 Greece' },
  { value: 'Grenada', label: '🇬🇩 Grenada' },
  { value: 'Guatemala', label: '🇬🇹 Guatemala' },
  { value: 'Guinea', label: '🇬🇳 Guinea' },
  { value: 'Guinea-Bissau', label: '🇬🇼 Guinea-Bissau' },
  { value: 'Guyana', label: '🇬🇾 Guyana' },
  { value: 'Haiti', label: '🇭🇹 Haiti' },
  { value: 'Honduras', label: '🇭🇳 Honduras' },
  { value: 'Hungary', label: '🇭🇺 Hungary' },
  { value: 'Iceland', label: '🇮🇸 Iceland' },
  { value: 'India', label: '🇮🇳 India' },
  { value: 'Iran', label: '🇮🇷 Iran' },
  { value: 'Ireland', label: '🇮🇪 Ireland' },
  { value: 'Italy', label: '🇮🇹 Italy' },
  { value: 'Ivory Coast', label: '🇨🇮 Ivory Coast' },
  { value: 'Jamaica', label: '🇯🇲 Jamaica' },
  { value: 'Japan', label: '🇯🇵 Japan' },
  { value: 'Kazakhstan', label: '🇰🇿 Kazakhstan' },
  { value: 'Kenya', label: '🇰🇪 Kenya' },
  { value: 'Kiribati', label: '🇰🇮 Kiribati' },
  { value: 'Kosovo', label: '🇽🇰 Kosovo' },
  { value: 'Kyrgyzstan', label: '🇰🇬 Kyrgyzstan' },
  { value: 'Laos', label: '🇱🇦 Laos' },
  { value: 'Latvia', label: '🇱🇻 Latvia' },
  { value: 'Lesotho', label: '🇱🇸 Lesotho' },
  { value: 'Liberia', label: '🇱🇷 Liberia' },
  { value: 'Liechtenstein', label: '🇱🇮 Liechtenstein' },
  { value: 'Lithuania', label: '🇱🇹 Lithuania' },
  { value: 'Luxembourg', label: '🇱🇺 Luxembourg' },
  { value: 'Madagascar', label: '🇲🇬 Madagascar' },
  { value: 'Malawi', label: '🇲🇼 Malawi' },
  { value: 'Maldives', label: '🇲🇻 Maldives' },
  { value: 'Mali', label: '🇲🇱 Mali' },
  { value: 'Malta', label: '🇲🇹 Malta' },
  { value: 'Marshall Islands', label: '🇲🇭 Marshall Islands' },
  { value: 'Mauritius', label: '🇲🇺 Mauritius' },
  { value: 'Mexico', label: '🇲🇽 Mexico' },
  { value: 'Micronesia', label: '🇫🇲 Micronesia' },
  { value: 'Moldova', label: '🇲🇩 Moldova' },
  { value: 'Monaco', label: '🇲🇨 Monaco' },
  { value: 'Mongolia', label: '🇲🇳 Mongolia' },
  { value: 'Montenegro', label: '🇲🇪 Montenegro' },
  { value: 'Mozambique', label: '🇲🇿 Mozambique' },
  { value: 'Myanmar', label: '🇲🇲 Myanmar' },
  { value: 'Namibia', label: '🇳🇦 Namibia' },
  { value: 'Nauru', label: '🇳🇷 Nauru' },
  { value: 'Nepal', label: '🇳🇵 Nepal' },
  { value: 'Netherlands', label: '🇳🇱 Netherlands' },
  { value: 'New Zealand', label: '🇳🇿 New Zealand' },
  { value: 'Nicaragua', label: '🇳🇮 Nicaragua' },
  { value: 'Niger', label: '🇳🇪 Niger' },
  { value: 'North Korea', label: '🇰🇵 North Korea' },
  { value: 'North Macedonia', label: '🇲🇰 North Macedonia' },
  { value: 'Norway', label: '🇳🇴 Norway' },
  { value: 'Palau', label: '🇵🇼 Palau' },
  { value: 'Panama', label: '🇵🇦 Panama' },
  { value: 'Papua New Guinea', label: '🇵🇬 Papua New Guinea' },
  { value: 'Paraguay', label: '🇵🇾 Paraguay' },
  { value: 'Peru', label: '🇵🇪 Peru' },
  { value: 'Philippines', label: '🇵🇭 Philippines' },
  { value: 'Poland', label: '🇵🇱 Poland' },
  { value: 'Portugal', label: '🇵🇹 Portugal' },
  { value: 'Romania', label: '🇷🇴 Romania' },
  { value: 'Russia', label: '🇷🇺 Russia' },
  { value: 'Rwanda', label: '🇷🇼 Rwanda' },
  { value: 'Saint Kitts and Nevis', label: '🇰🇳 Saint Kitts and Nevis' },
  { value: 'Saint Lucia', label: '🇱🇨 Saint Lucia' },
  {
    value: 'Saint Vincent and the Grenadines',
    label: '🇻🇨 Saint Vincent and the Grenadines',
  },
  { value: 'Samoa', label: '🇼🇸 Samoa' },
  { value: 'San Marino', label: '🇸🇲 San Marino' },
  { value: 'Sao Tome and Principe', label: '🇸🇹 Sao Tome and Principe' },
  { value: 'Senegal', label: '🇸🇳 Senegal' },
  { value: 'Serbia', label: '🇷🇸 Serbia' },
  { value: 'Seychelles', label: '🇸🇨 Seychelles' },
  { value: 'Sierra Leone', label: '🇸🇱 Sierra Leone' },
  { value: 'Singapore', label: '🇸🇬 Singapore' },
  { value: 'Slovakia', label: '🇸🇰 Slovakia' },
  { value: 'Slovenia', label: '🇸🇮 Slovenia' },
  { value: 'Solomon Islands', label: '🇸🇧 Solomon Islands' },
  { value: 'South Africa', label: '🇿🇦 South Africa' },
  { value: 'South Korea', label: '🇰🇷 South Korea' },
  { value: 'South Sudan', label: '🇸🇸 South Sudan' },
  { value: 'Spain', label: '🇪🇸 Spain' },
  { value: 'Sri Lanka', label: '🇱🇰 Sri Lanka' },
  { value: 'Suriname', label: '🇸🇷 Suriname' },
  { value: 'Sweden', label: '🇸🇪 Sweden' },
  { value: 'Switzerland', label: '🇨🇭 Switzerland' },
  { value: 'Taiwan', label: '🇹🇼 Taiwan' },
  { value: 'Tajikistan', label: '🇹🇯 Tajikistan' },
  { value: 'Tanzania', label: '🇹🇿 Tanzania' },
  { value: 'Thailand', label: '🇹🇭 Thailand' },
  { value: 'Timor-Leste', label: '🇹🇱 Timor-Leste' },
  { value: 'Togo', label: '🇹🇬 Togo' },
  { value: 'Tonga', label: '🇹🇴 Tonga' },
  { value: 'Trinidad and Tobago', label: '🇹🇹 Trinidad and Tobago' },
  { value: 'Turkmenistan', label: '🇹🇲 Turkmenistan' },
  { value: 'Tuvalu', label: '🇹🇻 Tuvalu' },
  { value: 'Uganda', label: '🇺🇬 Uganda' },
  { value: 'Ukraine', label: '🇺🇦 Ukraine' },
  { value: 'Uruguay', label: '🇺🇾 Uruguay' },
  { value: 'Uzbekistan', label: '🇺🇿 Uzbekistan' },
  { value: 'Vanuatu', label: '🇻🇺 Vanuatu' },
  { value: 'Vatican City', label: '🇻🇦 Vatican City' },
  { value: 'Venezuela', label: '🇻🇪 Venezuela' },
  { value: 'Vietnam', label: '🇻🇳 Vietnam' },
  { value: 'Zambia', label: '🇿🇲 Zambia' },
  { value: 'Zimbabwe', label: '🇿🇼 Zimbabwe' },
  { value: 'Other', label: '🌍 Other' },
]
